import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function DelayIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "14"}
      viewBox="0 0 14 14"
    >
      <g id="Icon" transform="translate(0.001 5.125)">
        <path
          id="Path_10160"
          data-name="Path 10160"
          d="M7.375-20.625a7,7,0,0,0-7,7,7,7,0,0,0,7,7,7,7,0,0,0,7-7A7,7,0,0,0,7.375-20.625Zm0,12.645A5.644,5.644,0,0,1,1.73-13.625,5.644,5.644,0,0,1,7.375-19.27a5.644,5.644,0,0,1,5.645,5.645A5.644,5.644,0,0,1,7.375-7.98Zm1.744-2.947A.341.341,0,0,0,9.594-11l.531-.731a.339.339,0,0,0-.073-.474L8.165-13.577v-4a.34.34,0,0,0-.339-.339h-.9a.34.34,0,0,0-.339.339v4.635a.341.341,0,0,0,.138.274Z"
          transform="translate(-0.376 15.5)"
          fill={color || "#2f2f2f"}
        />
      </g>
    </svg>
  );
}
